import React, { useEffect, useState } from 'react'
import { Flex, Layout } from 'antd'
import PanelHeader from './panel-header'
import PanelExpandCollapse from './panel-expand-collapse'
import PanelContent from './panel-content'
import { getCriticalConfig } from 'src/app/store/masterSetup'
import { useSelector } from 'react-redux'
import { LEFT_NAVIGATION_WIDTH, MINIMIZED_LEFT_NAVIGATION_WIDTH } from 'src/app/shared/constants/app.constants'
import { setLeftNavigationWidth } from 'src/app/store/common'
import { useDispatch } from 'react-redux'
import './index.scss'
import { useWindowSize } from 'src/app/shared/hooks/useWindowSize'

const { Sider } = Layout

const LeftNavigationPanel: React.FC = () => {
  const criticalConfig = useSelector(getCriticalConfig)
  const dispatch = useDispatch()
  const { mode } = useWindowSize()
  const [isMenuMinimized, setIsMenuMinimized] = useState<boolean>(mode === 'mobile')
  const [openKeys, setOpenKeys] = useState<Array<string>>([])
  const [openKeysBeforeMinimizing, setOpenKeysBeforeMinimizing] = useState<Array<string>>([])

  const { leftNavigationPanelBackgroundColor: panelBackgroundColor } = criticalConfig?.systemColor || {}

  const backgroundColorGradients = panelBackgroundColor?.split(' - ')

  const handleMinimizeMenu = () => {
    const body = document.querySelector('body')
    const className = 'collapsed'
    if (isMenuMinimized) {
      setOpenKeys(openKeysBeforeMinimizing)
      setIsMenuMinimized(false)
      dispatch(setLeftNavigationWidth(LEFT_NAVIGATION_WIDTH))
      body?.classList.remove(className)
    } else {
      setOpenKeysBeforeMinimizing(openKeys)
      setIsMenuMinimized(true)
      dispatch(setLeftNavigationWidth(MINIMIZED_LEFT_NAVIGATION_WIDTH))
      body?.classList.add(className)
    }
  }

  useEffect(() => {
    if (mode === 'mobile') {
      setIsMenuMinimized(true)
    } else {
      setIsMenuMinimized(false)
    }
  }, [mode])

  return (
    <div className='navigation-panel'>
      <Sider
        defaultCollapsed
        width={LEFT_NAVIGATION_WIDTH}
        trigger={null}
        collapsible
        collapsed={isMenuMinimized}
        style={{
          height: '100vh',
          maxHeight: '100vh',
          background: `linear-gradient(180deg, ${backgroundColorGradients?.[0]} 0%, ${backgroundColorGradients?.[1]} 100%)`,
        }}
      >
        <Flex style={{ maxHeight: '100vh' }} vertical>
          <PanelHeader isMenuMinimized={isMenuMinimized} handleMinimizeMenu={handleMinimizeMenu} />

          <PanelExpandCollapse openKeys={openKeys} setOpenKeys={setOpenKeys} isMenuMinimized={isMenuMinimized} />

          <PanelContent isMenuMinimized={isMenuMinimized} openKeys={openKeys} setOpenKeys={setOpenKeys} />
        </Flex>
      </Sider>
    </div>
  )
}

export default LeftNavigationPanel
